import {LoadingOutlined as AntdLoadingOutlined} from '@ant-design/icons';

export default function LoadingOutlined(props) {
  return <AntdLoadingOutlined {...props} />;
}
